export const enum PermissionEnum {
  CanManage = 628,
  DepartmentAdmin = 629,
  Purchaser = 630,
  FinancialProcessing = 631,
  GeneralAccess = 632,
  GodPermission = 0,
}

// 586	Can Edit THQ Response
// 139	Can Manage Command Annual Review
// 142	Command Annual Review General Access
// 143	Command Annual Review Team Leader
// 140	Command Annual Review Team Member

export const enum LocationLevel {
  NONHQ = 'NONHQ',
  DHQ = 'DHQ',
  THQ = 'THQ',
}

export enum EnumFaqSection {
  Dashboard = 'Dashboard',
  Admin = 'Admin',
}

export enum EnumModuleName {
  Name = 'Territorial Officers Advisory Commission',
}

export enum CorePermissionLevelEnum {
  Registrant,
  DisasterWorker,
  UnitAdmin,
  DivisionalEDSAdmin,
  TerritorialEDSAdmin,
  SystemAdmin,
}

export enum EdsDocumentTypeEnum {
  IncidentPhotos = 28,
  IncidentDocuments = 29,
  CommandPostDocs = 30,
  PersonnelDocs = 31,
  ResourceDocs = 32,
  StatisticsDocs = 33,
  TrainingDocs = 34,
  CertificationDocs = 35,
  GeneralDocs = 36,
  ProfileImages = 37,
}

export enum TravelTypeEnum {
  Flight = 'FL',
  Drive = 'DR',
  Ride = 'RD',
}

export enum CredentialingCodeEnum {
  COC = 'COC',
  PRS = 'PRS',
  WOL = 'WOL',
  BCK = 'BCK',
}

export const CredentialingCodeDescription: Record<CredentialingCodeEnum, string> = {
  [CredentialingCodeEnum.COC]: 'Code of Conduct',
  [CredentialingCodeEnum.PRS]: 'Photographic Release',
  [CredentialingCodeEnum.WOL]: 'Waiver of Liability',
  [CredentialingCodeEnum.BCK]: 'Background Check',
}

export enum PersonnelStatusEnum {
  Deployed = 'DEPLOYED',
  Standby = 'STANDBY',
  Dismissed = 'DISMISSED',
}